import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { GuestInfoForm } from '@/store/checkout';

@Component({
  name: 'CmgCheckoutGuestPickupInfo',
})
export default class CmgCheckoutGuestPickupInfo extends Vue {
  get form(): GuestInfoForm {
    return this.$appStore.state.checkout.guest.info;
  }

  get hasError(): boolean {
    for (const name of Object.keys(this.form)) {
      const field = (this.form as any)[name];

      if (field && field.error) {
        return true;
      }
    }

    return false;
  }
}
